import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=f8122354&"
import script from "./PaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports